import { useCallback } from "react";

import { useIntercom } from "react-use-intercom";

import { UserWithCompany } from "frontend/utils/types"; // TODO: Move this type into services/user/types
import { setDatadogSessionUser } from "lib/datadog";
import { identifyHeapUser } from "lib/heap";
import { identifyHotjarUser } from "lib/hotjar";
import { getIntercomInstanceData } from "lib/intercom";
import logger from "utils/logger";
/**
 * Consolidate all side-effects executed after authentication, to be called
 * on login or on cookie-auth on a subsequent visit.
 */
export function useExecuteOnAuthenticateSideEffects() {
  const intercom = useIntercom();
  const executeOnAuthenticateSideEffects = useCallback(
    ({
      user,
      impersonatorUser,
    }: {
      user: UserWithCompany;
      impersonatorUser: UserWithCompany | null;
    }) => {
      setDatadogSessionUser(user, impersonatorUser);
      try {
        intercom.update(getIntercomInstanceData(user, impersonatorUser));
      } catch (error) {
        logger.error("Failed to update Intercom", { error });
      }
      identifyHeapUser(user);
      identifyHotjarUser(user, impersonatorUser);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return { executeOnAuthenticateSideEffects };
}
